// extracted by mini-css-extract-plugin
export default {"logo_img":"Logo_logo_img__4AFAh","logo_link":"Logo_logo_link__AsB+x","logo_wrapper":"Logo_logo_wrapper__qKaQR"};